import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import NormalizeInput from '../../shared/phoneNumberSection/PhoneNumberUtility'
import { MFADomain } from '../../domain/mfa.services'
import Container from '../../shared/container/Container'
import { MFA } from '../MFASteps'
import { trackEventMessage, trackEventMessageFailure } from '../../../TelemetryService'
import { EventModel } from '../../../models/EventModel'
import { MFA_SETUP_SMS } from '../../../constants'
import { LoadingButton as Button } from '../LoadingButton/LoadingButton' 
import { TextInput } from 'carbon-components-react'

export const MFASmsEnrollment = ( { onGoBack, onSendCode, debounce, onClose, onChangePhoneNumber, webId, step } ) => {
const [ phoneNumber, setPhoneNumber ] = useState( '' )
const [ isNotValidPhone, setIsNotValidPhone ] = useState( false )

useEffect( () => {  

  return () => {    
    setPhoneNumber( '' )
    setIsNotValidPhone( false )
  }
}, [] )

const handleChangePhoneNumber = ( e ) => {    
    const value = e.target.value
    const formattedPhoneNumber = NormalizeInput( value )
    setPhoneNumber( formattedPhoneNumber )
    onChangePhoneNumber( value )
    setIsNotValidPhone( false )
 }

 const onHandleClick = async ( event ) => {
    trackEventMessage( new EventModel( MFA_SETUP_SMS.SEND_CODE, webId ) )
    event.preventDefault()
    if( phoneNumber.length >= 0 && MFADomain.IsPhoneValid( phoneNumber ) ) {
        try {
            const response = await onSendCode( MFA.FACTORS.SMS )
            if( !response ){
                setIsNotValidPhone( true )
            }
        } catch ( error ) {
            trackEventMessageFailure( new EventModel( MFA_SETUP_SMS.SEND_CODE_FAILURE, webId ), error )
        }
    }
    else{
          setIsNotValidPhone( true )
    }
}

const onHandleClose = ( ) => {
    trackEventMessage( new EventModel( MFA_SETUP_SMS.CLOSE, webId ) )
    onClose()
}

const handleGoBack = async ( event ) => {
    event.preventDefault()
    trackEventMessage( new EventModel( MFA_SETUP_SMS.GO_BACK, webId ) )
    onGoBack()
}

const validatePhone =  ( event ) => {
    event.preventDefault()
    setIsNotValidPhone( !MFADomain.IsPhoneValid( phoneNumber ) )
}

  return ( <Container onClose={ onHandleClose  } onCloseButtonId='dt-mfa-smssetup-close'>  
      <form >            
          <div className='mb-9'><header tabIndex='0' className='c-mfa-label--title' aria-label={ step.title }>{ step.title }</header></div>
          <div className="c-form-group mb-7">
              <TextInput labelText={ step.mobileNumber } className="c-form-input" id="smsPhoneNumber" type="text" required
                                        value={ phoneNumber } onBlur={ validatePhone } onChange={ handleChangePhoneNumber } aria-label={ MFA.SmsEnrollment.mobileNumber }
                                        invalidText= { isNotValidPhone ? step.invalidPhoneNumber : '' }
                                        inputMode='numeric'   
                                        data-testid="smsPhoneNumber"                           
                                        invalid={ isNotValidPhone }
                                        />
          </div> 
          <div>
              <Button debounce={ debounce } id='dt-mfa-smssetup-send-code' className={ ` ${ phoneNumber.length >= 0 && MFADomain.IsPhoneValid( phoneNumber ) ? 'c-btn c-btn--primary' : 'c-btn c-btn--disabled' } mb-5` } type="button" onClick={ onHandleClick } aria-label= { `${ MFA.SmsEnrollment.sendCode } ${ MFADomain.IsPhoneValid( phoneNumber ) ? 'enable' : 'disabled' } ` } name="sendCode" data-testid="btn-sendCode"> { MFA.SmsEnrollment.sendCode } </Button>
              <Button id='dt-mfa-smssetup-go-back' className={ 'c-btn c-btn--tertiary mb-6' } onClick={ handleGoBack } aria-label= { ` ${ MFA.goBack } Enabled` } name="goBack" type='button' data-testid="btn-goBack">{ MFA.goBack }</Button>
          </div>
          <div className='mb-7'><p tabIndex='0' className='c-mfa-card__footer' aria-label={ step.description }> { step.description } </p></div>
      </form> 
  </Container>  
   )
}

MFASmsEnrollment.propTypes = {
  onSendCode: PropTypes.func,
  onGoBack: PropTypes.func,
  onClose: PropTypes.func,
  onChangePhoneNumber: PropTypes.func,
  step: PropTypes.object,
  webId: PropTypes.string,
  debounce: PropTypes.bool
}

export default MFASmsEnrollment